module.exports = __webpack_public_path__ + "img/1565812654.473e3f8a.jpg";